var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as PropTypes from 'prop-types';
var TabStripTab = /** @class */ (function (_super) {
    __extends(TabStripTab, _super);
    function TabStripTab() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    TabStripTab.propTypes = {
        disabled: PropTypes.bool,
        contentClassName: PropTypes.string,
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.node
        ]),
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element,
            PropTypes.node
        ])
    };
    return TabStripTab;
}(React.Component));
export default TabStripTab;
//# sourceMappingURL=TabStripTab.js.map